var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0.5C27.165 0.5 35 8.33502 35 18C35 27.665 27.165 35.5 17.5 35.5C7.83502 35.5 0 27.665 0 18C0 8.33502 7.83502 0.5 17.5 0.5ZM27.5 15.5H25.8333L25.8302 15.7403C25.7028 20.6919 21.6489 24.6667 16.6667 24.6667C16.508 24.6667 16.35 24.6626 16.1925 24.6546L18.0893 22.7559L16.9107 21.5774L12.9882 25.5L16.9107 29.4226L18.0893 28.2441L16.1654 26.3219C16.332 26.3295 16.4991 26.3333 16.6667 26.3333C22.5643 26.3333 27.3612 21.6207 27.497 15.7557L27.5 15.5ZM18.0893 6.57741L16.9107 7.75592L18.834 9.67805C18.6676 9.67047 18.5007 9.66667 18.3333 9.66667C12.4357 9.66667 7.63881 14.3793 7.50296 20.2443L7.5 20.5H9.16667L9.16975 20.2597C9.29719 15.3081 13.3511 11.3333 18.3333 11.3333C18.492 11.3333 18.6501 11.3374 18.8075 11.3454L16.9107 13.2441L18.0893 14.4226L22.0118 10.5L18.0893 6.57741Z",
    fill: "#007683"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.39baeb11c300e7ccd24b69109344f921.svg";
export { ForwardRef as ReactComponent };